import React from 'react';

function RadiusDropdown({ radius, onRadiusChange, isOpen, onToggle }) {
  const getButtonText = () => {
    if (radius === '9999') {
      return '30+ miles';
    }

    return radius ? `${radius} miles` : 'Radius';
  };

  const radiusOptions = [
    { value: '1', label: 'Within 1 mile' },
    { value: '3', label: 'Within 3 miles' },
    { value: '5', label: 'Within 5 miles' },
    { value: '10', label: 'Within 10 miles' },
    { value: '20', label: 'Within 20 miles' },
    { value: '9999', label: '30+ miles' },
  ];

  return (
    <fieldset className="xl:border-l-2 bg-white h-15 border-[#ebebeb] lg:h-full lg:bg-none flex items-center justify-center relative">
      <legend className="sr-only">Radius</legend>
      <button
        type="button"
        className="text-sm font-medium flex items-center gap-3 lg:h-15"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        {getButtonText()}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          aria-hidden="true"
          focusable="false"
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
          }}
        >
          <use href="#icon-chevron-down" />
        </svg>
      </button>
      {isOpen && (
        <div className="z-50 absolute w-full bg-white top-full -left-[2px] p-4 border-2 border-[#ebebeb] xl:min-w-52">
          <div>
            <label
              className="block font-light text-xs mb-2"
              htmlFor="radius-select"
            >
              Search radius
            </label>
            <div className="relative">
              <select
                id="radius-select"
                className="px-3 min-h-[42px] bg-grey-100 w-full border border-[#ebebeb] appearance-none"
                name="radius"
                value={radius}
                onChange={(e) => onRadiusChange(e.target.value)}
              >
                {radiusOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="7"
                viewBox="0 0 10 7"
                fill="none"
                aria-hidden="true"
                focusable="false"
                className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
              >
                <use href="#icon-chevron-down" />
              </svg>
            </div>
          </div>
        </div>
      )}
    </fieldset>
  );
}

export default RadiusDropdown;
